<template>
    <button :type="type" class="inline-flex items-center px-4 py-2 bg-white border border-gray rounded-md font-semibold text-xs text-pGray uppercase tracking-widest shadow-sm hover:text-gray focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-200 active:text-pGray active:bg-gray disabled:opacity-25 transition">
        <slot></slot>
    </button>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            type: {
                type: String,
                default: 'button',
            },
        }
    })
</script>
